import { Observable, of, throwError, BehaviorSubject } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';
import { AccessTokenData, AccountTypeEnum, Auth0OrighinEnum, CareerProcessTypeEnum, DateData, OrgDataUpdateComparison, OrgDataUpdateReport, OrgDataUpdateRun, PersonalUserData, ResellerData, ResellerTokesStatusData, ResellerTokesStatusData_String, SkipRelationshipQuestionsData, UserAlert, UserAuth0RedactedData, UserCreatedOrgData, UserCVMetadata, UserMinimalData } from './personal-user-data';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { APIS } from 'src/app/apis';
import { LocalStorageService } from '../localStorage';
import { LocalStorageKeys } from '../localStorage/local-storage.enum';
import config from '../../../config';
import { TranslateService } from '@ngx-translate/core';
import { Gender } from '../../enum/gender.enum';
import { AbstractPersonalUserDataService } from './personal-user-data.abstract.service';
import { AbstractLocalStorageService } from '../localStorage/local-storage.abstract.service';
import { AbstractAuthorizationService } from '../authorization/authorization.abstract.service';
import { AppInjector } from '../../app-injector';
import { UtilsService } from '../utils/utils.service';
import { InternalEventsManagerService } from '../internal-events-manager/internal-events-manager.service';
import { ServerResponseType } from '@azure/msal-browser';
import { UserCompetenciesData } from '../chat/strcutredProcess-data';
@Injectable({
  providedIn: 'root'
})
export class PersonalUserDataService implements AbstractPersonalUserDataService  {

  // user urls start
  private userDetailsUrl = `${APIS.user}/user`;
  private userMinimalDetailsUrl = `${APIS.user}/getUserMinimalDetails`;
  private userImageUrl = `${APIS.user}/userImage`;
  private userInsightsReports = `${APIS.user}/userInisightsReport`;
  private userUpdateDetailsUrl = `${APIS.user}/updateUser`;
  private userUpdatePasswordUrl = `${APIS.user}/updatePassword`;
  private userResetPassword = `${APIS.user}/resetUserPassword`;
  private setRelationshipDataUrl = `${APIS.user}/setRelationshipData`;
  private getIsMissingRelationshipUrl = `${APIS.user}/missingRelationship`;
  private getAlertsForCounterpartUrl = `${APIS.user}/getAlertsForCounterpart`;
  private sendFeedbackUrl = `${APIS.user}/sendFeedback`;
  private approvePrivacyPolicyUrl = `${APIS.user}/approvePrivacyPolicy`;
  private sendDiscoveryReminderUrl = `${APIS.user}/sendDiscoveryReminder`;
  private resellerUsageReportUrl = `${APIS.user}/resellerUsageReport`;
  private selfResellerDetailsUrl = `${APIS.user}/getSelfResellerData`;
  private reallocateAccessTokensByAmountUrl = `${APIS.user}/reallocateAccessTokensByAmount`;
  private reallocateAccessSpecificTokensUrl = `${APIS.user}/reallocateSpecficAccessTokens`;
  private verifyFeatureUrl = `${APIS.user}/verifyFeature`;
  private getDiscoveryProcessEndDateUrl = `${APIS.user}/getDiscoveryProcessEndDate`;
  private getResellerTokensStatusUrl = `${APIS.user}/getResellerActiveTokensStatus`;
  private getResellerActiveTokensForOrgUrl = `${APIS.user}/getResellerActiveTokensForOrg`;
  private getAllUserCreatedOrgsUrl = `${APIS.user}/getAllUserCreatedOrgs`;
  private createOrgByUserUrl = `${APIS.user}/createOrgByUser`;
  private editOrgDetailsUrl = `${APIS.user}/editOrgDetails`;
  private deleteOrgUrl = `${APIS.user}/deleteOrg`;
  private adminConvertUserToResellerUrl = `${APIS.user}/adminConvertUserToReseller`;
  private adminSetExpirationDateToOrgUrl = `${APIS.user}/adminSetExpirationDateToOrg`;
  private allocateTokensToGroupUrl = `${APIS.user}/allocateTokensToGroup`;
  private adminChangeParentToUsersUrl = `${APIS.user}/adminChangeParentToUsers`;
  private adminChangeOrgToUsersUrl = `${APIS.user}/adminChangeOrgToUsers`;
  private unsubscribeMailUrl = `${APIS.user}/unsubscribeMail`;
  private verifyPhoneNumber_stage1Url = `${APIS.user}/verifyPhoneNumber_stage1`;
  private verifyPhoneNumber_stage2Url = `${APIS.user}/verifyPhoneNumber_stage2`;
  private uploadCVUrl = `${APIS.user}/uploadCV`;
  private getUserAuth0RedactedDataUrl = `${APIS.user}/getUserAuth0RedactedData`;
  private updateUserAuth0DetailsUrl = `${APIS.user}/updateUserAuth0Details`;
  private deleteUserAuth0DetailsUrl = `${APIS.user}/deleteUserAuth0Details`;
  private adminGetLastOrgDataUpdateReportUrl = `${APIS.user}/adminGetLastOrgDataUpdateReport`;
  private adminPreviewOrgDataUpdateUrl = `${APIS.user}/adminPreviewOrgDataUpdate`;
  private adminApplyOrgDataUpdateUrl = `${APIS.user}/adminApplyOrgDataUpdate`;
  private adminGetOrgDataUpdateRunsUrl = `${APIS.user}/adminGetOrgDataUpdateRuns`;
  private adminGetOrgDataUpdateRunUrl = `${APIS.user}/adminGetOrgDataUpdateRun`;
  private adminCompareOrgDataUpdateRunsUrl = `${APIS.user}/adminCompareOrgDataUpdateRuns`;
  private getUserCVMetadataUrl = `${APIS.user}/getUserCVMetadata`;
  private setUserCompetenciesUrl = `${APIS.user}/setUserCompetencies`;
  private getUserCompetenciesUrl = `${APIS.user}/getUserCompetencies`;
  private adminForcePasswordUrl = `${APIS.user}/adminForcePassword`;
  // user urls end

  relationshipSkipList: SkipRelationshipQuestionsData [] = [];

  constructor(
    public http: HttpClient,
    public localStorageService: AbstractLocalStorageService,
    public translate: TranslateService,
    public authorizationService: AbstractAuthorizationService,
    public readonly utilsService: UtilsService,
    private internalEventsService: InternalEventsManagerService
  ) {

  }


  public getResetUserPasswordUrl(): string {
    return this.userResetPassword;
  }  

  public static getUserLocale(): string {
    const injector = AppInjector.getInjector();
    let localStorageService = injector.get(LocalStorageService); 
  
    let userData;
    try {
      userData = localStorageService.get<PersonalUserData>(LocalStorageKeys.userPersonalInfo);
      if (userData) {
        console.log('in getUserLocale in the if userdata');
        
        const locale = userData.locale ? userData.locale.toString() : config.defaultLocale;
        return locale;
      } else {
        throw (new Error(`Logged In user details were not fond on LocalStorage`));
      }
    } catch (e) {
      // throw (new Error(`Logged In user details were not fond on LocalStorage`));
      // console.log(`Logged In user details were not fond on LocalStorage`);
    }
    
    return config.defaultLocale;
  }

  

  setUserDetails (locale: string, gender: number, phoneNumber: string, phoneNumberCountryCode: string, presentFullHierarchy:boolean, engagementLevel: number, preferredEngagementCahnnel: number, shouldGetQuestioner : boolean, allowShareMotivations: boolean, allowShareCalendar: boolean): Observable<string>{
    let result = this.http.post<string>(this.userUpdateDetailsUrl, {  locale: locale, 
                                                                      gender:gender, 
                                                                      phoneNumber:phoneNumber, 
                                                                      phoneNumberCountryCode:phoneNumberCountryCode, 
                                                                      presentFullHierarchy:presentFullHierarchy, 
                                                                      engagementLevel: engagementLevel, 
                                                                      preferredEngagementCahnnel: preferredEngagementCahnnel, 
                                                                      shouldGetQuestioner: shouldGetQuestioner, 
                                                                      allowShareMotivations:allowShareMotivations,
                                                                      allowShareCalendar: allowShareCalendar }, {});
    return result;
  }

  updateUserPassword (oldPassword: string, newPassword: string): Observable<HttpResponse<string>>{
    return this.http.post<string>(this.userUpdatePasswordUrl, { oldPassword: oldPassword, newPassword:newPassword }, {observe : 'response'});
  }

  resetUserPassword (userMail: string): Observable<string>{
    let result = this.http.get<string>(`${this.userResetPassword}?userMail=${userMail}`);            
    return result;
  }

  getUnsubscribeUrl(): string{
    return this.unsubscribeMailUrl;
  }

  getVerifyFeatureUrl(): string{
    return this.verifyFeatureUrl;
  }

  unsubscribeMail(userMail: string, unsubscribeType:string): Observable<string>{
    let result = this.http.get<string>(`${this.unsubscribeMailUrl}?userMail=${userMail}&unsubscribeType=${unsubscribeType}`);            
    return result;
  }

  setRelationship (counterpartId: string, costOfSeperation: number, chanceOfSeperation: number): Observable<string>{
    let result = this.http.post<string>(this.setRelationshipDataUrl, { counterpartId: counterpartId, costOfSeperation: costOfSeperation, chanceOfSeperation: chanceOfSeperation }, {});
    return result;
  }

  isMissingRelationship (counterpartId: string): Observable<boolean>{
    let result = this.http.get<boolean>(`${this.getIsMissingRelationshipUrl}?counterpartId=${counterpartId}`);            

    return result;
  }

  sendDiscoveryReminder (counterpartId: string): Observable<string>{
    let result = this.http.get<string>(`${this.sendDiscoveryReminderUrl}?counterpartId=${counterpartId}`);            

    return result;
  }

  getAlertsForCounterpart (counterpartId: string): Observable<UserAlert[]>{
    let result = this.http.get<UserAlert[]>(`${this.getAlertsForCounterpartUrl}?counterpartId=${counterpartId}`);            

    return result;
  }

  sendFeedback (issue: string, text: string): Observable<string>{
    let result = this.http.post<string>(this.sendFeedbackUrl, { issue: issue, text: text}, {});
    return result;
  }

  isUserLoggedIn(): boolean {
      const token = this.localStorageService.getSecured<string>(LocalStorageKeys.moovToken);
      if (token){
        if (!this.authorizationService.isTokenExpired(token)) {
          return true;
        } else {
          return false;
        }  
      }
      else{
        return false;
      }
  }


  getLoggedInUserPersonalData(): PersonalUserData | undefined {
    // const localStorageService: LocalStorageService = new LocalStorageService();
    try {
      const userData = this.localStorageService.get<PersonalUserData>(LocalStorageKeys.userPersonalInfo);
      if (userData) {
        return userData;
      } else {
        return undefined;
      }
    } catch (e) {
      // throw (new Error(`Logged In user details were not fond on LocalStorage`));
      // console.log(`Logged In user details were not fond on LocalStorage`);
      return undefined;
    }
  }

  getUserLocale(): string {
    const userData = this.getLoggedInUserPersonalData();
    let locale = "";
    
    if (userData){
      locale = userData.locale.toString();
    }
    else{
      locale = this.utilsService.getBrowserLocale();
    }
    return locale;
  }

  getLoggedInUserGender(): Gender {
    const userData = this.getLoggedInUserPersonalData();

    if (userData){
      if (userData.gender == Gender.NON_BINARY){
        return Gender.FEMALE;
      }

      return userData.gender;
    }
    return config.defaultGender;
  }

  logout() {
    this.internalEventsService.userLoggedOut.emit();
  }

  personalilze() {
    this.setLocale();
  }

  getUserDetails(userId: string): Observable<PersonalUserData> {
    return this.http.get<PersonalUserData>(`${this.userDetailsUrl}/${userId}`);
  }

  getMinimalUserDetails(userId: string): Observable<UserMinimalData> {
    return this.http.get<UserMinimalData>(`${this.userMinimalDetailsUrl}?userId=${userId}`);
  }


  approvePrivacyPolicy(): Observable<any>{
    let retVal =  this.http.get<any>(`${this.approvePrivacyPolicyUrl}`);
      return of (true);
  }

  getUserImage(userId: string): Observable<ArrayBuffer>  {
    return this.http.get(`${this.userImageUrl}?userId=${userId}`, { responseType: 'arraybuffer' });            
  }
 
  getUserInsightsReport(): Observable<ArrayBuffer> {
    return this.http.get(`${this.userInsightsReports}`, { responseType: 'arraybuffer' });            
  }

  setLocale(overrideLocale = "") {
    this.translate.addLangs(config.supportedLocales);
    let defaultLocale: string = config.defaultLocale; // en-US, he-IL,..
    this.translate.setDefaultLang(defaultLocale);
    
    let userLang = overrideLocale;
    if (overrideLocale == ""){
      userLang = this.getUserLocale();
    }

    let bIsLocaleSupported = false;
    for (let langIndex: number = 0; langIndex < config.supportedLocales.length; langIndex++){
      if (config.supportedLocales[langIndex] == userLang){
        bIsLocaleSupported = true;
      }
    }

    if (!bIsLocaleSupported){
      userLang = defaultLocale;
    }

    // console.log(`setLocale userLang `+userLang);
    this.localStorageService.write(LocalStorageKeys.userSelectedLocale, userLang);
    this.translate.use(userLang);
  }

  shouldSkipRelationshipQuestion(userId: string, counterpartId: string): boolean{
    let skipList = undefined;
    let retVal = false;
    
    try {
      skipList = this.localStorageService.get<SkipRelationshipQuestionsData[]>(LocalStorageKeys.skipRelationshipQuestionData);
      } catch (ex) {
        // console.log(`in personal-user-data.service, skip list was not found in local storage`);
        // do nothing, skiplist will remain undefined
    }

    let skipListIndexToDelete = -1;

    if (skipList){
      skipList.forEach((item, index) => {
          if (item){
            if (item.userId == userId && item.counterpartId == counterpartId) {
              let now = new Date();
              let than = new Date (item.timestamp);
              let hoursDelta = (now.getTime() - than.getTime())/(1000*3600);
              if (hoursDelta > config.relationshipSkiplistTTL_hours ){
                // entry not relevant delete it
                skipListIndexToDelete = index;
              }
              else{
                retVal = true;
              }
          }
          }
        });
      
     // remove outdated records
      if (skipListIndexToDelete != -1){
        delete skipList[skipListIndexToDelete];
        this.localStorageService.write<SkipRelationshipQuestionsData[]>(LocalStorageKeys.skipRelationshipQuestionData, skipList);
      }
    }

    return retVal;
  }

  postponeRelationshipsQuestion(userId:string, counterpartId: string) : void{
    let skipList = undefined;
    let foundEntry = false;
    
    try {
      skipList = this.localStorageService.get<SkipRelationshipQuestionsData[]>(LocalStorageKeys.skipRelationshipQuestionData);
      } catch (ex) {
        // console.log(`in personal-user-data.service, skip list was not found in local storage`);
        // do nothing, skiplist will remain undefined
    }

    if (!skipList){
      skipList = [{userId:userId, counterpartId:counterpartId, timestamp:new Date()}]
    }
    else{
        skipList.forEach((item, index) => {
          if (item.userId == userId && item.counterpartId == counterpartId) {
            let now = new Date();
            item.timestamp = now;
            foundEntry = true;
          }
        });

        if (!foundEntry){
          const now = new Date()
          skipList = skipList.concat([{userId:userId, counterpartId:counterpartId, timestamp:now}]);
        }

      }
      
    this.localStorageService.write<SkipRelationshipQuestionsData[]>(LocalStorageKeys.skipRelationshipQuestionData, skipList);
     
  }

  getSelfResellerData (): Observable<ResellerData> {
    return this.http.get<ResellerData>(`${this.selfResellerDetailsUrl}`);
  }

  getResellerUsageReport(usersList: string): Observable<ArrayBuffer> {
    return this.http.get(`${this.resellerUsageReportUrl}?usersList=${usersList}`, { responseType: 'arraybuffer' });            
  }

  reallocateAccessTokenByAmount(resllerMail: string, tokensAmount:number, accountType: AccountTypeEnum, careerProcessType: CareerProcessTypeEnum): Observable<AccessTokenData[]>{
    return this.http.post<AccessTokenData[]>(`${this.reallocateAccessTokensByAmountUrl}`, {resellerTargetMail:resllerMail, accessTokensAmount:tokensAmount, accountType:accountType, careerProcessType:careerProcessType});
  }

  reallocateSpecificAccessToken(resllerMail: string, specificTokensList:string): Observable<string[]>{
    return this.http.post<string[]>(`${this.reallocateAccessSpecificTokensUrl}`, {resellerTargetMail:resllerMail, accessTokensList:specificTokensList});
  }

  verifyFeature(featureId: string) : Observable<boolean>{
    let userData = this.getLoggedInUserPersonalData();

    if (userData == undefined){
      return of (false);
    }
    else{
      // console.log(`verifyFeature user data is ${JSON.stringify(userData)}`);
      return this.http.get<boolean>(`${this.verifyFeatureUrl}?featureId=${featureId}`);
    }
  }

  getDiscoveryProcessEndDate() : Observable<DateData>{
    return this.http.get<DateData>(`${this.getDiscoveryProcessEndDateUrl}`);
}

convertKeysToInt(obj: { [key: string]: number }): Map<number, number> {
  const map = new Map<number, number>();
  Object.keys(obj).forEach(key => {
    map.set(Number(key), obj[key]);
  });
  return map;
}

getResellerTokensStatus() : Observable<ResellerTokesStatusData_String>{
  return this.http.get<ResellerTokesStatusData_String>(`${this.getResellerTokensStatusUrl}`);
}

getResellerActiveTokensForOrg(orgId: string): Observable<AccessTokenData[]>{
  return this.http.get<AccessTokenData[]>(`${this.getResellerActiveTokensForOrgUrl}?orgId=${orgId}`);
}

getAllUserCreatedOrgs(userIdOverride : string = ""): Observable<UserCreatedOrgData[]>{
  return this.http.get<UserCreatedOrgData[]>(`${this.getAllUserCreatedOrgsUrl}?userIdOverride=${userIdOverride}`);
}

 createOrgByUser(name: string, description:string) : Observable<string>{
  return this.http.post<string>(`${this.createOrgByUserUrl}`, {name:name, description:description});
 }

 editOrgDetails(orgId: string, name: string, description: string) : Observable<string>{
  return this.http.post<string>(`${this.editOrgDetailsUrl}`, {orgId:orgId, name:name, description:description});
 }

 deleteOrg(orgId: string) : Observable<string>{
  return this.http.post<string>(`${this.deleteOrgUrl}`, {orgId:orgId});
 }


 allocateTokensToGroup(orgId: string, tokensNo: number, accountType: AccountTypeEnum, careerProcessType: CareerProcessTypeEnum) : Observable<AccessTokenData[]>{
  return this.http.post<AccessTokenData[]>(`${this.allocateTokensToGroupUrl}`, {orgId:orgId, tokensNo:tokensNo, accountType: accountType, careerProcessType: careerProcessType});
 }
 
 adminChangeParentToUsers(parentMail: string, subordinatesList: string): Observable<string[]>{
  return this.http.post<string[]>(`${this.adminChangeParentToUsersUrl}`, {parentMail:parentMail, subordinatesList:subordinatesList});
 }
 
 adminChangeOrgToUsers(orgId: string, usersList: string): Observable<string[]>{
  return this.http.post<string[]>(`${this.adminChangeOrgToUsersUrl}`, {orgId:orgId, usersList:usersList});
 }

 adminConvertUserToReseller(userMail:string): Observable<string>{
  return this.http.get<string>(`${this.adminConvertUserToResellerUrl}?userMail=${userMail}`)
 }

 adminSetExpirationDateToOrg(orgId:string, expirationDate: Date): Observable<string>{
  console.log(`calling ${this.adminSetExpirationDateToOrgUrl}`);
  return this.http.post<string>(`${this.adminSetExpirationDateToOrgUrl}`, {orgId: orgId, expirationDate: expirationDate});
 }

 verifyPhoneNumber_stage1(): Observable<string>{
  return this.http.get<string>(`${this.verifyPhoneNumber_stage1Url}`);
}

verifyPhoneNumber_stage2(code : string): Observable<boolean>{
  return this.http.get<boolean>(`${this.verifyPhoneNumber_stage2Url}?code=${code}`);
}

getUserCVMetadata(): Observable<UserCVMetadata | undefined>{
  return this.http.get<UserCVMetadata | undefined>(`${this.getUserCVMetadataUrl}`);
}

uploadCV(file: File): Observable<string>{
  const formData = new FormData();
  formData.append('file', file, file.name);

  return this.http.post<string>(this.uploadCVUrl, formData);
}

updateUserAuth0Details(userUPN: string, origin: Auth0OrighinEnum, accessToken: string, idToken: string): Observable<string>{
  return this.http.post<string>(`${this.updateUserAuth0DetailsUrl}`, {userUPN: userUPN, origin: origin, accessToken: accessToken, idToken: idToken});
}

deleteUserAuth0Details(origin: Auth0OrighinEnum): Observable<string>{
  return this.http.get<string>(`${this.deleteUserAuth0DetailsUrl}?origin=${origin}`);
}

getUserAuth0RedactedData(origin: Auth0OrighinEnum): Observable<UserAuth0RedactedData | undefined>{
  return this.http.get<UserAuth0RedactedData>(`${this.getUserAuth0RedactedDataUrl}?origin=${origin}`);
}

adminGetLastOrgDataUpdateReport(orgId: string): Observable<OrgDataUpdateReport>{
  return this.http.get<OrgDataUpdateReport>(`${this.adminGetLastOrgDataUpdateReportUrl}?orgId=${encodeURIComponent(orgId)}`);
}

adminPreviewOrgDataUpdate(orgId: string): Observable<OrgDataUpdateRun>{
  return this.http.post<OrgDataUpdateRun>(this.adminPreviewOrgDataUpdateUrl, {orgId});
}

adminApplyOrgDataUpdate(orgId: string, runId: string): Observable<OrgDataUpdateRun>{
  return this.http.post<OrgDataUpdateRun>(this.adminApplyOrgDataUpdateUrl, {orgId, runId});
}

adminGetOrgDataUpdateRuns(orgId: string, limit: number = 50): Observable<OrgDataUpdateRun[]>{
  return this.http.get<OrgDataUpdateRun[]>(`${this.adminGetOrgDataUpdateRunsUrl}?orgId=${encodeURIComponent(orgId)}&limit=${limit}`);
}

adminGetOrgDataUpdateRun(orgId: string, runId: string): Observable<OrgDataUpdateRun>{
  return this.http.get<OrgDataUpdateRun>(`${this.adminGetOrgDataUpdateRunUrl}?orgId=${encodeURIComponent(orgId)}&runId=${encodeURIComponent(runId)}`);
}

adminCompareOrgDataUpdateRuns(orgId: string, fromRunId: string, toRunId: string): Observable<OrgDataUpdateComparison>{
  return this.http.get<OrgDataUpdateComparison>(`${this.adminCompareOrgDataUpdateRunsUrl}?orgId=${encodeURIComponent(orgId)}&fromRunId=${encodeURIComponent(fromRunId)}&toRunId=${encodeURIComponent(toRunId)}`);
}

public setUserCompetencies(userCompetencies: UserCompetenciesData): Observable<string> {
  return this.http.post<string>(`${this.setUserCompetenciesUrl}`, userCompetencies);
}

public getUserCompetencies(): Observable<UserCompetenciesData | null> {
  return this.http.get<UserCompetenciesData | null>(`${this.getUserCompetenciesUrl}`);
}

adminForcePassword(userMail: string, newPassword: string): Observable<string> {
  return this.http.post(`${this.adminForcePasswordUrl}`, { userMail, newPassword }, { responseType: 'text' });
}

}
